module.exports = __webpack_public_path__ + "img/DSC_0329.09ea52ef.jpg";